import Client from "..";
import { BasicButton } from "./BasicButton";

export class SpinButton extends BasicButton {
  constructor(scene: Phaser.Scene) {
    super(
      scene,
      "Spin",
      {
        textureKey: "Button1",
      },
      {
        textureKey: "Button2",
      },
      undefined,
      undefined,
    );
    this.background.setTint(0xac4c3f);
  }

  handlePointerDown(): void {
    // Custom behavior for pointer down
    Client.stateMachine.SpinWheel();
  }

  handlePointerOver(): void {
    // Custom behavior for pointer over
  }

  handlePointerUp(): void {
    // Custom behavior for pointer up
  }

  handlePointerOut(): void {
    // Custom behavior for pointer out
  }
}
